import { z } from 'zod';
import { uuidSchema } from './common.js';
/**
 * Les DÉPENSES COURANTES d'une boutique.
 *
 * ⭐ Ce qu'on paie pour tourner, et qui n'entre pas dans le stock : loyer,
 * électricité, transport, petit matériel. Les achats de marchandise ont leur
 * propre circuit — les mêler fausserait la marge autant que la trésorerie.
 *
 * ⚠️ Les montants sont des ENTIERS (ADR-10). Jamais de flottant sur de
 * l'argent : 0,1 + 0,2 ne fait pas 0,3 en binaire, et une caisse qui ne tombe
 * juste qu'à un centime près n'est pas une caisse.
 */
export const MOYENS_PAIEMENT_DEPENSE = ['cash', 'mobile', 'card', 'transfer', 'other'];
export const LIBELLES_MOYEN_DEPENSE = {
    cash: 'Espèces',
    mobile: 'Mobile money',
    card: 'Carte',
    transfer: 'Virement',
    other: 'Autre',
};
// ------------------------------------------------------------- catégories
export const categorieDepenseInputSchema = z.object({
    id: uuidSchema.optional(),
    name: z.string().trim().min(2, 'Au moins 2 caractères').max(80),
    color: z.string().trim().max(20).optional(),
    position: z.coerce.number().int().min(0).default(0),
});
// --------------------------------------------------------------- dépenses
export const depenseInputSchema = z.object({
    id: uuidSchema.optional(),
    categoryId: uuidSchema.optional().or(z.literal('').transform(() => undefined)),
    label: z.string().trim().min(2, 'Au moins 2 caractères').max(160),
    amount: z.coerce.number().int().positive('Montant requis'),
    currencyCode: z.string().trim().length(3).optional(),
    /**
     * La date de la DÉPENSE, pas celle de la saisie.
     *
     * ⚠️ Une date CIVILE « AAAA-MM-JJ », sans heure ni fuseau : on enregistre
     * souvent le lundi la facture du samedi, et c'est le samedi qui compte. Un
     * instant aurait fait basculer la dépense d'un jour selon le poste.
     */
    spentOn: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Date attendue en AAAA-MM-JJ'),
    paymentMethod: z.enum(MOYENS_PAIEMENT_DEPENSE).default('cash'),
    supplierName: z.string().trim().max(160).optional(),
    notes: z.string().trim().max(2000).optional(),
});
export const depenseQuerySchema = z.object({
    q: z.string().trim().max(120).optional(),
    categoryId: uuidSchema.optional(),
    /** Bornes CIVILES incluses, pour découper par jour, mois ou année. */
    du: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
    au: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    offset: z.coerce.number().int().min(0).default(0),
});
//# sourceMappingURL=depense.js.map